const chars =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export function encodeNumber(num: number): string {
  if (num <= 0) return "aa";
  let result = "";
  while (num > 0) {
    result = chars[num % 62] + result;
    num = Math.floor(num / 62);
  }
    return result.padStart(2, 'a');
}

export function decodeString(str: string): number {
  let num = 0;
  for (let char of str) {
    num = num * 62 + chars.indexOf(char);
  }
  return num;
}